export const LOG_MESSAGES = {
  NOT_FOUND: 'No log records were found',
};

export const EXPORT_LOGS_CSV_MESSAGES = {
  NOT_FOUND: 'No Logs was exported',
};


// WEBPACK FOOTER //
// ./src/features/log/constants/logMessages.js